import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AccountV2NavigationComponentDef } from '@df/account/v2/navigation/account-v2-navigation.component.def';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { LogoutButtonComponent } from '../../ui/common/logout-button.component';
declare module '@df/account/account.interfaces' {
    namespace Account {
        interface INavigationItem {
            icon?: string;
            mobileLabel?: string;
        }
    }
}
@Component({
    selector: 'account-navigation',
    templateUrl: './account-navigation.html',
    styleUrls: ['./account-navigation.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, LogoutButtonComponent, GridModule, RouterLink, IfSizeDirective]
})
export class AccountNavigationComponent extends AccountV2NavigationComponentDef {
}
